var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn beauty-btn",class:_vm.btnClass,style:(_vm.btnStyle),attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._t("default"),_vm._v(_vm._s(_vm.label)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }